var $ = require('jquery');
/*
 * Map of element tag names to action_cause
 */
var ACTION_CAUSE = {
    'LINK': 'link_click',
    'A': 'link_click',
    'BUTTON': 'button_click',
    'IMG': 'image_click',
    'SELECT': 'select_change',
    'INPUT': 'user_input',
    'FORM': 'button_click'
};

var CONTROL_ELEMENTS = ['INPUT', 'SELECT', 'OPTION'];

/*
 * default value for action_cause
 */
var DEFAUL_ACTION_CAUSE = 'link_click';
var ENTRY_GLOBAL_NAV_ID = 'edm-entry-global-nav';

/**
 * Finds a creative of the element and returns it's idenrifier
 * @param  {Object} $element
 * @return {String|undefined}
 */
function getElementCreativeId($element) {
    var $creative = $element.closest('.edm-entry, .modal-drawer');
    if ($creative && $creative.length > 0) {
        return $creative.attr('id');
    } else if($element.closest('#nav-drawer').length) {
        return ENTRY_GLOBAL_NAV_ID;
    }
}

/**
 *
 * @param $element
 * @return {*}
 */
function getActionCause($element) {
    var tagName = $element.prop('tagName');
    if($element.hasClass('btn-link')) {
        tagName = 'LINK';
    } else if ($element.is('[class^="btn"]')){
        tagName = 'BUTTON';
    }
    return ACTION_CAUSE[tagName] || DEFAUL_ACTION_CAUSE;
}

/**
 *
 * @param $element
 * @return {boolean}
 */
function isControlElement($element) {
    return CONTROL_ELEMENTS.indexOf($element.prop('tagName')) !== -1;
}

/**
 *
 * @param $element
 */
function getActionValue($element) {
    var trackingValue = $element.data('tracking-value');

    if (typeof trackingValue === 'undefined') {
        trackingValue = isControlElement($element) ?
            $element.val() : $element.text().trim();

        // TODO: if do not have nested elements
    }
    return trackingValue;
}

function isAdsRefreshDisabled($element, noRefresh) {
    var globalNav = $('.global-nav');
    return globalNav.has($element).length <= 0 && $element.attr('href')
        || noRefresh;
}

module.exports = {
    getElementCreativeId: getElementCreativeId,
    getActionCause: getActionCause,
    isControlElement: isControlElement,
    getActionValue: getActionValue,
    isAdsRefreshDisabled: isAdsRefreshDisabled
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/element-engagement-handler/helper.js
// module id = 434
// module chunks = 36